import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { genIdempotencyKey } from "../../utils/genIdempotencyKey";
import { accountGroupsV4PerformanceEntireKeyMaker } from "../requests/getAccountGroupPerformancesV4";
import { getEventsV4KeyMaker } from "../requests/getEventsV4";
import { getForwardLookingV4KeyMaker } from "../requests/getForwardLookingV4";
import { getHistoricalV4KeyMaker } from "../requests/getHistoricalV4";
import { getHoldingsV4KeyMaker } from "../requests/getHoldingsV4";
import { getProjectionsV4KeyMaker } from "../requests/getProjectionsV4";
import { getScenariosV4KeyMaker } from "../requests/getScenariosV4";
import patchAccountGroupsV4 from "../requests/patchAccountGroupsV4";
import clearMemoizedCaches from "../utilities/clearMemoizedCaches";
import { accountGroupsV4KeyMaker } from "./useGetAccountGroupsV4";
import { singleAccountGroupV4KeyMaker } from "./useGetSingleAccountGroupV4";
export default function usePatchAccountGroupsV4(config) {
    const queryClient = useQueryClient();
    const idemDescriptor = "patch-account-groups-v4";
    const [idempotencyKey, setIdempotencyKey] = useState(genIdempotencyKey(idemDescriptor));
    const mutation = useMutation({
        mutationFn: async (input) => {
            if (config === null) {
                throw new Error("no auth");
            }
            await patchAccountGroupsV4(input.accountGroupId, input.body, idempotencyKey, config);
        },
        onSuccess: (_, { accountGroupId, clientId, body }) => {
            setIdempotencyKey(genIdempotencyKey(idemDescriptor));
            queryClient.invalidateQueries({
                queryKey: singleAccountGroupV4KeyMaker(accountGroupId),
            });
            queryClient.invalidateQueries({
                queryKey: accountGroupsV4KeyMaker(),
            });
            // if just patch'ing displayName and/or isFavorite no need to invalidate AGs performance
            if ("virtualAccountIds" in body) {
                // This should be first as the invalidateQueries will call a network response immediately
                clearMemoizedCaches();
                // AGs performance
                queryClient.removeQueries({
                    queryKey: accountGroupsV4PerformanceEntireKeyMaker(clientId),
                });
                queryClient.removeQueries({
                    queryKey: getEventsV4KeyMaker(accountGroupId),
                });
                queryClient.removeQueries({
                    queryKey: getHoldingsV4KeyMaker(accountGroupId),
                });
                queryClient.removeQueries({
                    queryKey: getForwardLookingV4KeyMaker(accountGroupId),
                });
                queryClient.removeQueries({
                    queryKey: getHistoricalV4KeyMaker(accountGroupId),
                });
                queryClient.removeQueries({
                    queryKey: getProjectionsV4KeyMaker(accountGroupId),
                });
                queryClient.removeQueries({
                    queryKey: getScenariosV4KeyMaker(accountGroupId),
                });
            }
        },
    });
    return mutation.mutateAsync;
}
//# sourceMappingURL=usePatchAccountGroupsV4.js.map